import TalentSidebar from "./TalentSidebar_updated";
import UserSidebar from "./UserSidebar_upated";
import { useCurrentTalentProfile } from "../hooks";
import BusinessSidebar from "./BusinessSidebar";
import useCurrentBusinessInfo from "../hooks/useCurrentBusiness";

type AppSidebarProps = {
  open: boolean;
  setDrawerOpen: (open: boolean) => void;
};

export default function AppSidebar({ open, setDrawerOpen }: AppSidebarProps) {
  const { currentProfile } = useCurrentTalentProfile();
  const { currentBusiness } = useCurrentBusinessInfo();

  const handleClose = () => {
    setDrawerOpen(false);
  };

  return currentProfile ? (
    <TalentSidebar open={open} handleClose={handleClose} />
  ) : currentBusiness ? (
    <BusinessSidebar open={open} handleClose={handleClose} />
  ) : (
    <UserSidebar open={open} handleClose={handleClose} />
  );
}
